import React from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { updateAllCheckedFlights } from "../searchFlightsSlice";
import { useTranslation } from "react-i18next";

function AllFlightsCheckbox() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const checked = useAppSelector(
    (state) => state.searchFlights.results.checkedFlights["all"]
  );

  const onChange = () => {
    dispatch(updateAllCheckedFlights(!checked));
  };

  return (
    <input
      type="checkbox"
      title={t("CLIPBOARD_ALL_CHECKBOX_TITLE")}
      checked={checked === undefined ? false : checked}
      onChange={onChange}
    />
  );
}

export default AllFlightsCheckbox;
